import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { handleError } from "../../utils/handleError";

const initialState = {
	isLoading: true,
	error: null,
	message: null,
	allEmails: [],
	pagination: {
		total: 0,
		page: 1,
		totalPages: 10
	}
};
const setPending = (state) => {
	state.isLoading = true;
};
const setRejected = (state, action) => {
	state.isLoading = false;
	state.error = action.payload?.message;
	state.message = null;
};

const emailSlice = createSlice({
	name: 'admin-emails',
	initialState,
	reducers: {
		clearError: (state) => {
			state.error = null;
		},
		clearMessage: (state) => {
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllEmails.pending, setPending)
			.addCase(fetchAllEmails.rejected, setRejected)
			.addCase(fetchAllEmails.fulfilled, (state, action) => {
				state.isLoading = false;
				state.allEmails = action.payload.allEmails || [];
				state.pagination = action.payload.pagination;
			})
			.addCase(adminSendEmail.pending, setPending)
			.addCase(adminSendEmail.rejected, setRejected)
			.addCase(adminSendEmail.fulfilled, (state, action) => {
				state.isLoading = false;
				state.message = action.payload?.message || null;
			})

	},
});


export const fetchAllEmails = createAsyncThunk(
	'admin/fetchAllEmails',
	async ({page=1,limit=5}, { rejectWithValue }) => {
		try {
			let url = window.location.href
		let link = url.includes('?') ? `?${url.split("?")[1]}&limit=${limit}&page=${page}` : `?limit=${limit}&page=${page}`;
			const res = await axiosInstance.get(`/admin/email/fetch-all${link}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const deleteById = createAsyncThunk(
	'admin/deleteById',
	async (id, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/admin/email/delete/${id}`);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

export const deleteBulk = createAsyncThunk(
	'admin/deleteBulk',
	async (ids, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/admin/email/bulk`, {ids});
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);

// Thunks
export const adminSendEmail = createAsyncThunk(
	'dashboard/getDashboardData',
	async (data, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.post('/admin/email/send',data);
			return res.data;
		} catch (error) {
			return rejectWithValue(handleError(error));
		}
	}
);


export const { clearError, clearMessage } = emailSlice.actions;
export default emailSlice.reducer;
